import React from "react";
import { PiSuitcaseRolling } from "react-icons/pi";
import { SlHandbag } from "react-icons/sl";
import "./PublicOfferIncludedBaggageCard.css";

/**
 * בלוק בולט לכבודה כלולה בהצעת מחיר ללקוח (?offer=1).
 * @param {{ hasIncluded: boolean, items?: { key: string, label: string }[], passengerNote?: string, emptyMessage?: string }} vm
 */
export default function PublicOfferIncludedBaggageCard({ vm }) {
  if (!vm) return null;

  return (
    <section
      className={`public-offer-included-baggage${vm.hasIncluded ? "" : " public-offer-included-baggage--none"}`}
      dir="rtl"
      aria-labelledby="public-offer-included-baggage-title"
    >
      <div className="public-offer-included-baggage__header">
        <PiSuitcaseRolling className="public-offer-included-baggage__header-icon" aria-hidden />
        <h3 id="public-offer-included-baggage-title" className="public-offer-included-baggage__title">
          כבודה כלולה
        </h3>
      </div>

      {vm.hasIncluded ? (
        <>
          <ul className="public-offer-included-baggage__list">
            {vm.items.map((item) => {
              const Ico = item.key === "carryOn" ? SlHandbag : PiSuitcaseRolling;
              return (
                <li key={item.key} className="public-offer-included-baggage__item">
                  <span className="public-offer-included-baggage__item-icon-wrap" aria-hidden>
                    <Ico className="public-offer-included-baggage__item-icon" />
                  </span>
                  <span className="public-offer-included-baggage__item-label">{item.label}</span>
                </li>
              );
            })}
          </ul>
          {vm.passengerNote ? (
            <p className="public-offer-included-baggage__note">{vm.passengerNote}</p>
          ) : null}
          <p className="public-offer-included-baggage__footnote">כבודה כלולה בטיסה/חבילה</p>
        </>
      ) : (
        <p className="public-offer-included-baggage__empty">{vm.emptyMessage}</p>
      )}
    </section>
  );
}
